(() => {
  const roots = document.querySelectorAll('[data-celina-pdp]');
  if (!roots.length) return;

  roots.forEach((root, index) => {
    if (root.dataset.celinaPortalReady === 'true') return;
    const drawer = root.querySelector('[data-celina-drawer]');
    if (!drawer) return;
    const getDrawerScroller = () => drawer.querySelector('.celina-pdp__drawer-inner') || drawer;

    root.dataset.celinaPortalReady = 'true';
    const uid = root.dataset.sectionId || `celina-${index}`;
    drawer.dataset.celinaPortalDrawer = uid;
    document.body.appendChild(drawer);

    let backdrop = document.querySelector(`[data-celina-portal-backdrop="${uid}"]`);
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'celina-pdp__portal-backdrop';
      backdrop.dataset.celinaPortalBackdrop = uid;
      document.body.appendChild(backdrop);
    }

    const setTab = (name) => {
      root.querySelectorAll('[data-celina-tab]').forEach((tab) => {
        const isActive = tab.dataset.celinaTab === name;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      root.querySelectorAll('[data-celina-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.celinaPanel === name);
      });
    };

    const openDrawer = () => {
      setTab('actives');
      root.classList.add('is-drawer-open', 'is-actives-tab');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.classList.add('is-open');
      document.body.classList.add('celina-pdp-drawer-portal-open');
      document.documentElement.classList.add('celina-pdp-drawer-portal-open');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      drawer.style.overflow = 'hidden';
      const scroller = getDrawerScroller();
      scroller.style.overflowY = 'auto';
      scroller.style.webkitOverflowScrolling = 'touch';
      scroller.scrollTop = 0;
    };

    const closeDrawer = (reset = true) => {
      root.classList.remove('is-drawer-open', 'is-actives-tab');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove('is-open');
      document.body.classList.remove('celina-pdp-drawer-portal-open');
      document.documentElement.classList.remove('celina-pdp-drawer-portal-open');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      drawer.style.overflow = '';
      const scroller = getDrawerScroller();
      scroller.style.overflowY = '';
      scroller.style.webkitOverflowScrolling = '';
      if (reset) setTab('details');
    };

    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-celina-close-drawer]');
      if (closeButton && drawer.contains(closeButton)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        closeDrawer(true);
        return;
      }

      const activesTab = event.target.closest('[data-celina-tab="actives"]');
      const openButton = event.target.closest('[data-celina-open-drawer]');
      if ((activesTab && root.contains(activesTab)) || (openButton && root.contains(openButton))) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openDrawer();
        return;
      }

      const otherTab = event.target.closest('[data-celina-tab]');
      if (otherTab && root.contains(otherTab) && otherTab.dataset.celinaTab !== 'actives') {
        closeDrawer(false);
        return;
      }

      if (drawer.classList.contains('is-open') && !drawer.contains(event.target)) {
        closeDrawer(true);
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(true);
    });

    backdrop.addEventListener('click', () => closeDrawer(true));
  });
})();


// HOTFIX CELINA — corrige a galeria mobile após o Swiper/variante inicial reposicionar slides.
// Escopo: somente produto com Celina PDP, somente mobile, somente no carregamento inicial.
(() => {
  const run = () => {
    if (!window.matchMedia || !window.matchMedia('(max-width: 899px)').matches) return;

    document
      .querySelectorAll('.wt-product__wrapper:has(.celina-pdp) .wt-product > .wt-product__gallery')
      .forEach((gallery) => {
        const wrapper = gallery.querySelector('[data-gallery] [data-swiper-container]');
        if (!wrapper) return;

        wrapper.querySelectorAll('[data-swiper-slide], .swiper-slide').forEach((slide) => {
          slide.style.order = '';
        });

        try {
          if (gallery.gallerySwiper && typeof gallery.gallerySwiper.update === 'function') {
            gallery.gallerySwiper.update();
          }
          if (gallery.gallerySwiper && typeof gallery.gallerySwiper.slideTo === 'function') {
            gallery.gallerySwiper.slideTo(0, 0, false);
          }
          if (gallery.thumbsSwiper && typeof gallery.thumbsSwiper.slideTo === 'function') {
            gallery.thumbsSwiper.slideTo(0, 0, false);
          }
        } catch (error) {}
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('load', () => {
    run();
    setTimeout(run, 250);
    setTimeout(run, 900);
  }, { once: true });
})();
